var exports = {
  "Zl": "pullRequestLink__zIOr27",
  "w9": "pullRequestLinkExternal__O8W1Aa",
  "il": "pullRequestLinkInternal__ApuBkT",
  "Zr": "pullRequestTitle___dBUAj",
  "fd": "externalRepoContainer__Y6Q6pR",
  "aR": "repositoryName__oXKy83",
};

module.exports = exports;
